let hideTimeout = null;
let showTimeout = null;

// TODO Implement better screen sizes and toggle logic
$(document).ready(function () {
    let menuDropdowns = $('.menu.menu--basic > .nav-item.dropdown');

    for (let i = 0; i < menuDropdowns.length; i++) {
        menuDropdowns[i].addEventListener("mouseenter", function (e) {
            let mediaQuery = $('body').data('mediaquery');
            if (mediaQuery !== "xs" && mediaQuery !== "sm") {
                activateMenu($(this), 300);
            }
        });

        menuDropdowns[i].addEventListener("mouseleave", function (e) {
            let mediaQuery = $('body').data('mediaquery');
            if (mediaQuery !== "xs" && mediaQuery !== "sm") {
                hideMenu($(this), 300);
            }
        });
    }
    // Open-Close Navigation
    $('.mobileMenuTrigger').click(function () {
        $(this).toggleClass('is-active');
        $('.mobile-navigation').toggleClass('active');
        $($(this).parent()).toggleClass('active-nav');
        $('html').toggleClass('mobileactive fullheight');
        $('.header').toggleClass("active-mobile-header");
    });
});

// Show Submenu
function activateMenu(row, delay) {
    // Hide all others
    clearTimeout(hideTimeout);
    clearTimeout(showTimeout);

    // Show active
    showTimeout = setTimeout(function () {
        let dropdowns = $('.dropdown-menu');
        for (let i = 0; i < dropdowns.length; i++) {
            dropdowns[i].classList.remove('active-menu');
        }
        $(row).find('.dropdown-menu')[0].classList.add('active-menu');
    }, delay);
}

function hideMenu(row, delay) {
    hideTimeout = setTimeout(function () {
        $(row).find('.dropdown-menu')[0].classList.remove('active-menu');
    }, delay)
}

document.addEventListener('scroll', (event) => {
    const navbarHeader = document.querySelector('.headerWrapper');

    if (navbarHeader) {
        const navbarHeaderOffsetTop = $(navbarHeader).offset().top;
        const isNavbarHeaderStickyOnScroll = window.scrollY === navbarHeaderOffsetTop;

        // Add is-pinned class to header when user scrolls down
        if (isNavbarHeaderStickyOnScroll) {
            navbarHeader.classList.add('is-pinned');
        } else if (window.scrollY < navbarHeaderOffsetTop) {
            navbarHeader.classList.remove('is-pinned');

            // Add dynamic margin top to dropdown menus when navbar is not pinned
            const dropdownMenus = navbarHeader.querySelectorAll('.active-mobile-header.dropdown-menu');

            if (dropdownMenus.length > 0) {
                dropdownMenus.forEach(function (dropdownMenu) {
                    const dropdownNegativeMarginTopValue = '-' + (window.scrollY + 10) + 'px';

                    dropdownMenu.style.marginTop = dropdownNegativeMarginTopValue;
                });
            }
        }
    }
});

// Offcanvas menu level 2+3 back logic and hide offcanvas menus on navbar collapse
document.addEventListener('preloaded', function (event) {
    const offcanvasMenuLevel3BackButtons = document.querySelectorAll('.btn-close-menu-level-3');
    const navbarCollapse = document.querySelector('.navbar-collapse');

    if (offcanvasMenuLevel3BackButtons.length > 0) {
        offcanvasMenuLevel3BackButtons.forEach(function (offcanvasMenuLevel3BackButton) {
            offcanvasMenuLevel3BackButton.addEventListener('click', function (event) {
                const offcanvasMenuLevel3Index = $(offcanvasMenuLevel3BackButton).parents('.offcanvas-menu-level-3').data('index');
                const offcanvasMenuLevel2 = document.querySelector('.offcanvas-menu-level-2[data-index="' + offcanvasMenuLevel3Index + '"]');

                if (offcanvasMenuLevel2) {
                    $(offcanvasMenuLevel2).offcanvas('show');
                }
            });
        });
    }

    if (navbarCollapse) {
        navbarCollapse.addEventListener('hide.bs.collapse', event => {
            $('.offcanvas-menu-level-2').offcanvas('hide');
            $('.offcanvas-menu-level-3').offcanvas('hide');
        })
    }
}, false);
